'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLikert = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ScopedD3Base = require('../ScopedD3Base');

var _ScopedD3Base2 = _interopRequireDefault(_ScopedD3Base);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colorsPatterns = require('./colorsPatterns');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var d3 = require('d3');

// general
var margin = { top: 0, right: 20, bottom: 0, left: 20 };
var maxBarHeight = 50;
var minRowPadding = 2;
var total_height = 38;

var defaultOptions = {
  colors: _colorsPatterns.defaultColors,
  diverging: true,
  usePatterns: true,
  // this option only used in legend below
  continuous: false,
  maxBarHeight: maxBarHeight
};

var renderLikert = exports.renderLikert = (0, _ScopedD3Base2.default)(function (_ref) {
  var spanData = _ref.spanData,
      svg = _ref.svg,
      g = _ref.g,
      tooltip = _ref.tooltip;
  var getContainer = spanData.getContainer,
      scale = spanData.scale,
      options = spanData.options,
      data = spanData.data,
      min = spanData.min,
      height = spanData.height,
      width = spanData.width;


  var useOptions = _extends({}, defaultOptions, options || {});
  var colors = useOptions.colors;
  var usePatterns = useOptions.usePatterns;

  // fill in any missing values with 0s
  data.map(function (d, i) {
    return scale.filter(function (k) {
      return data[i][k] === undefined;
    }).forEach(function (k) {
      data[i][k] = 0;
    });
  });

  var stack = d3.stack().keys(scale)(data);

  // establish margin up front, replace top-level g 
  g = g.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
  width = width - margin.left - margin.right;

  var maxLeft = 0;
  var xScale = 1;
  var getLeft = function getLeft() {
    return 0;
  };

  if (useOptions.diverging) {
    // get max left (negative) offset of likert, for midpoint of stack
    maxLeft = stack.length % 2 ? d3.max(stack[Math.ceil(stack.length / 2) - 1], function (a) {
      return a[0] + (a[1] - a[0]) / 2;
    }) : d3.max(stack[stack.length / 2 - 1], function (a) {
      return a[1];
    });

    // and right
    var maxRight = stack.length % 2 ? d3.max(stack[Math.ceil(stack.length / 2) - 1], function (a) {
      return 1 - (a[0] + (a[1] - a[0]) / 2);
    }) : d3.max(stack[stack.length / 2 - 1], function (a) {
      return 1 - a[1];
    });

    // func for getting left offset of one row
    getLeft = function getLeft(i) {
      return stack.length % 2 ? function (a) {
        return a[0] + (a[1] - a[0]) / 2;
      }(stack[Math.ceil(stack.length / 2) - 1][i]) : stack[stack.length / 2 - 1][i][1];
    };

    // get scaled range horizontally to fit all
    xScale = maxLeft + maxRight;
  }

  var barHeight = Math.min.apply(null, data.map(function (d, i) {
    return (data[i + 1] ? data[i + 1].rect.offsetY : height) - data[i].rect.offsetY - minRowPadding * 2;
  }).concat([useOptions.maxBarHeight]));

  var rowPadding = function rowPadding(i) {
    return ((data[i + 1] ? data[i + 1].rect.offsetY : height) - data[i].rect.offsetY - barHeight) / 2;
  };

  var fills = scale.map(function (s, i) {
    return !useOptions.diverging && useOptions.continuous ? (0, _colorsPatterns.getColorContinuous)(scale.length, i, colors) : (0, _colorsPatterns.getColor)(scale.length, i, colors);
  });

  if (usePatterns) {
    fills = scale.map(function (s, i) {
      return !useOptions.diverging && useOptions.continuous ? (0, _colorsPatterns.getFillContinuous)(scale.length, i, colors) : (0, _colorsPatterns.getFill)(scale.length, i, colors);
    });
    fills.forEach(function (t) {
      return t && svg.call(t);
    });
  }

  var rowsInd = new Array(data.length).fill().map(function (d, i) {
    return i;
  });

  var rows = g.selectAll('g.row').data(rowsInd).enter().append('g').attr('class', 'row').attr('transform', function (d, i) {
    return 'translate(' + maxLeft * (1 / xScale) * width + ', ' + (data[i].rect.offsetY + rowPadding(i)) + ')';
  });

  var rowsInner = rows.append('g').attr('transform', function (d) {
    return 'scale(0,1)';
  });

  rowsInner.transition().duration(500).attr('transform', function (d) {
    return 'scale(' + 1 / xScale + ')';
  });

  rows.transition().delay(500).duration(1000).attr('transform', function (d, i) {
    return 'translate(' + (useOptions.diverging ? (maxLeft - (getLeft(i) || 0)) * (1 / xScale) * width : 0) + ', ' + (data[i].rect.offsetY + rowPadding(i)) + ')';
  });

  var boxes = rowsInner.selectAll('rect').data(function (d) {
    return stack.map(function (s) {
      return _extends({}, s, { i: s[d] });
    });
  }).enter().append('rect').attr('class', function (d) {
    return 'likert-box-' + d.index + ' box';
  }).attr('y', 0).attr('height', barHeight).attr('x', function (d) {
    return d['i'][0] * width;
  }).attr('width', function (d) {
    return d['i'][1] ? (d['i'][1] - d['i'][0]) * width : 0;
  }).style('fill', function (d) {
    return usePatterns ? fills[d.index].url() : fills[d.index];
  });

  var shadows = rowsInner.selectAll('.box-label-s').data(function (d) {
    return stack.map(function (s) {
      return _extends({}, s, { i: s[d] });
    }).filter(function (s) {
      return !isNaN(s['i'][1]) && s['i'][1] - s['i'][0] > .1;
    });
  }).enter().append('text').attr('class', 'box-label-s').attr('y', barHeight / 2 + 6).attr('x', function (d) {
    return d['i'][0] * width + (d['i'][1] - d['i'][0]) * width / 2;
  }).attr('opacity', 0).text(function (d) {
    return Math.round(d['i'].data[d.key] * 100) + '%';
  }).attr('style', '\n        stroke: white;\n        stroke-width: 4;\n        text-anchor: middle;\n      ');

  var labels = rowsInner.selectAll('.box-label').data(function (d) {
    return stack.map(function (s) {
      return _extends({}, s, { i: s[d] });
    }).filter(function (s) {
      return !isNaN(s['i'][1]) && s['i'][1] - s['i'][0] > .1;
    });
  }).enter().append('text').attr('class', 'box-label').attr('y', barHeight / 2 + 6).attr('x', function (d) {
    return d['i'][0] * width + (d['i'][1] - d['i'][0]) * width / 2;
  }).attr('opacity', 0).attr('style', '\n        stroke: black;\n        stroke-width: 1;\n        text-anchor: middle;\n      ').text(function (d) {
    return Math.round(d['i'].data[d.key] * 100) + '%';
  });

  shadows.transition().delay(1500).duration(500).attr('opacity', 0.9);
  labels.transition().delay(1700).duration(500).attr('opacity', 1);

  if (useOptions.diverging) {
    var center = maxLeft * (1 / xScale) * width;

    var refline = g.append('line').attr('x1', center).attr('x2', center).attr('y1', 0).attr('y2', height).attr('stroke', '#555555');
  }

  boxes.on("mouseover", function (d) {
    tooltip.transition().duration(200).style("opacity", .9);
    tooltip.html('<div>' + d.key + '<br/>' + (d['i'].data[d.key] * 100).toFixed(0) + '%</div>').style("left", Math.round(d3.event.layerX || d3.event.offsetX) + "px").style("top", Math.round(d3.event.layerY || d3.event.offsetY - 28) + "px");
  }).on("mouseout", function (d) {
    tooltip.transition().duration(500).style("opacity", 0);
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/react-likert/lib/components/visualizations/LikertRenderer.js
// module id = 272
// module chunks = 168707334958949